// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/topback.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/royalty-banner.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/gold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/bg-chat.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary: #ffb400;
  --secondary: #0d0d2b;
  --text-dark: #000;
  --text: #fff;
}

body {
  background-color: var(--secondary) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: #040015;
  /* font-family: "Montserrat", sans-serif !important; */
}

.main {
  background-position: center center !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  overflow-x: hidden;
  background-color: #040015;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--text);
}

p {
  color: var(--text);
}

img {
  width: 100%;
}

a:hover {
  color: #00e1ff !important;
}

.modal-header {
  border: none !important;
}

.modal-body h5 {
  color: var(--text-dark);
  text-align: center;
}

.modal-content {
  background-color: var(--primary) !important;
}

.custom-btn {
  background-color: var(--primary);
  color: var(--text-dark) !important;
  padding: 16px 36px;
  border-radius: 6px;
  text-decoration: none;
  transition: all 0.5s;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  border: 1px solid var(--primary);
  cursor: pointer;
  font-family: Ubuntu;
  z-index: 1;
}

.custom-tp {
  background-color: transparent;
  color: var(--primary);
  border: 1px solid var(--primary);
  padding: 16px 36px;
  border-radius: 6px;
  text-decoration: none;
  transition: all 0.5s;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
}

.custom-btn:hover {
  background-color: transparent;
  color: #00e1ff;
  /* border: 1px solid var(--primary); */
}

.custom-nav-btn:hover {
  background-color: transparent;
  color: #00e1ff;
  /* border: 1px solid var(--primary); */
}

.signup-btn {
  background: linear-gradient(90deg, rgb(2, 77, 119) 0%, rgb(50, 181, 207) 51%, rgb(14, 193, 239) 100%, rgb(5, 157, 248) 100%);
  color: var(--text-white) !important;
  padding-right: 10px;
  padding-left: 35px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 100px;
  text-decoration: none;
  transition: all 0.5s;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  cursor: pointer;
  font-family: Ubuntu;
  border: none;
}

.signup-btn:hover {
  background-color: transparent;
  background: linear-gradient(90deg, rgb(8, 103, 156) 0%, rgb(26, 196, 230) 51%, rgb(14, 193, 239) 100%, rgb(41, 166, 241) 100%);
}

.custom-tp:hover {
  background-color: var(--primary);
  color: var(--text-dark) !important;
  border: 1px solid var(--primary);
}

.btn-grp a {
  margin-right: 20px;
}

.section-padding {
  padding: 5rem 0;
  position: relative;
}

.section-bg {
  /* background-image: url(../images/image-8.png); */
  background-size: cover;
  background-position: top;
}

.nav-bg {
  background-color: rgba(29, 25, 44, 0.5490196078);
}

/* 
.section-bg::after{

  content: "";
  position: absolute;
  display: inline-block;
  width: 100%;
  background-image: linear-gradient(180deg,#0000,var(--secondary));
  height: 100px;


  } */
.top-header {
  background-color: var(--primary);
  text-align: center;
  padding: 15px 0;
}

.middle-back {
  z-index: 1;
}

.bottom-back {
  z-index: 1;
}

.logo {
  height: 37px;
}

.nav-custom {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  color: var(--text);
  z-index: 9999;
  height: 90px;
  padding: 0 3rem;
}

.navbar-light .navbar-nav .nav-link {
  color: var(--text) !important;
  font-size: 16px;
  line-height: 24px;
  font-family: Ubuntu;
}

.nav-item {
  padding: 0 20px;
  position: relative;
}

.navbar-nav {
  align-items: center;
}

.nav-link {
  position: relative;
}

.nav-link::after {
  content: "";
  background-color: var(--primary);
  position: absolute;
  height: 2px;
  width: 0;
  left: 0;
  transition: 0.5s ease-in;
  bottom: 0;
}

@media screen and (min-width: 480px) {
  .nav-link:hover::after {
    width: 100%;
  }
}
/* .active::after {
  content: "";
  background-color: var(--primary);
  position: absolute;
  height: 2px;
  width: 100%;
  left: 0;
  transition: 0.5s ease-in;
  bottom: 0;
} */
.main-title {
  align-items: center;
  position: relative;
  display: flex;
}

.main-title hr {
  background-color: var(--primary);
  height: 2px !important;
  width: 10%;
  margin: 0 !important;
}

.main-title p {
  font-weight: 500;
  font-size: 18px;
  position: relative;
  padding-left: 55px;
}

.main-title p::before {
  position: absolute;
  content: "";
  width: 50px;
  height: 2px;
  background-color: var(--primary);
  display: inline-block;
  left: 0%;
  top: 50%;
}

.stars {
  position: absolute;
  right: 0;
}

.stars img:nth-child(1) {
  height: 64px;
  width: 64px;
}

.stars img:nth-child(2) {
  height: 34px;
  width: 34px;
  top: 50px;
  right: -100px;
  position: absolute;
}

.main-img {
  /* background-image: url(../images/image\\ 2.png); */
  background-size: contain;
  background-position: 100% 0;
  display: flex;
  justify-content: center;
  background-repeat: no-repeat;
  padding: 30px 0;
}

.main-img img {
  width: 500px;
}

.line-grid {
  width: 100%;
}

.main-gif img {
  max-width: 470px;
}

.rotate {
  animation: rotation 8s infinite linear;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
.title {
  text-align: center;
  font-family: orbitron;
}

.sub-title {
  font-family: Ubuntu;
  color: #dfdfdf;
  font-size: 30px;
}

.home-title h1 {
  font-weight: 500;
  font-family: ag;
  color: #00e1ff;
}

.title p {
  letter-spacing: 2px;
}

.download-btn {
  padding-top: 50px;
  max-width: 200px;
  cursor: pointer;
}

.download-btn:hover {
  opacity: 0.73;
}

.title h1 {
  font-size: 50px;
  line-height: 75px;
  text-align: left;
}

.title h2 {
  font-weight: 500;
  font-size: 40px;
  letter-spacing: 2px;
}

.title h1 span {
  color: var(--primary);
}

.heythere {
  width: 600px;
}

.aboutus {
  font-family: Ubuntu;
  width: -webkit-fill-available;
  display: flex;
  justify-content: center;
}

.stick-icon {
  width: 150px;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}

.stick-icon-right {
  width: 150px;
  position: absolute;
  top: 50%;
  transform: translate(-10px, 10px) rotate(272deg);
  right: 0;
}

.main-box,
.main-box-lg {
  padding: 20px;
  margin: 43px 0;
  display: flex;
  justify-content: space-around;
  align-items: baseline;
  flex-direction: row;
}

.main-button {
  margin-top: 50px;
}

.main-box p {
  font-size: 18px;
  line-height: 27px;
  opacity: 0.7;
}

.main-box-lg p {
  font-size: 28px;
  line-height: 37px;
  opacity: 0.7;
}

.main-box span,
.main-box-lg span {
  font-weight: 900;
}

.main-box a,
.main-box-lg a {
  color: white;
}

.info-box {
  display: flex;
  align-items: flex-start;
  background: linear-gradient(112deg, #000000 4.11%, #ffffff 4.11%, rgba(255, 255, 255, 0.5) 100%);
  padding: 20px;
  border: 1px solid var(--text);
  height: 184px;
}

.info-box-yellow {
  background: linear-gradient(112deg, #000000 4.11%, #ffb400 4.11%, #ffb400 100%);
}

.info-box img {
  width: 50px;
}

.info-img {
  background-color: var(--text);
  border-radius: 50%;
  padding: 10px;
  margin-right: 10px;
}

.info-box-details {
  display: flex;
  color: var(--text-dark);
  flex-direction: column;
}

.info-box-details h3 {
  color: var(--text-dark);
  font-weight: 600;
  font-size: 48px;
}

.info-box-details p {
  color: var(--text-dark);
  font-size: 18px;
  line-height: 27px;
}

.sm-title {
  color: var(--primary);
  font-weight: 500;
  font-size: 16px;
  margin: 0;
}

.lg-title {
  font-weight: 600;
  font-size: 47px;
  line-height: 58px;
}

.sm-des {
  font-size: 16px;
  line-height: 29px;
  opacity: 0.7;
}

.social-btn {
  display: flex;
  justify-content: center;
}

.social-btn ul {
  padding: 0;
  display: flex;
  list-style: none;
  align-items: center;
  flex-wrap: wrap;
}

.social-btn img {
  width: 60px;
  height: 60px;
  margin-right: 15px;
}

.profile-name {
  color: #A77032 !important;
  font-family: monster;
}

.section-img {
  width: 400px;
}

.img-grp {
  display: flex;
  flex-wrap: wrap;
}

.img-grp > div {
  flex-basis: 50%;
}

.img-grp img {
  width: 200px;
}

.subscribe {
  position: relative;
  display: flex;
  align-items: center;
}

.subscribe input:not(input[type=submit]) {
  width: 100%;
  border-radius: 32px;
  padding: 15px;
}

.subscribe input::placeholder {
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
}

.submit-ab {
  border: none;
  background-color: var(--primary);
  position: absolute;
  right: 5px;
  width: 25%;
  border-radius: 32px;
  padding: 10px 10px;
  font-weight: 500;
  font-size: 18px;
}

footer {
  background-color: rgba(255, 255, 255, 0.031372549);
  padding-top: 50px;
  z-index: 999;
}

.footer-liks {
  margin-top: 5rem !important;
}

.footer-menu {
  color: var(--text);
  padding: 0;
}

.footer-menu li {
  padding: 12px 0;
}

.footer-menu a {
  color: var(--text);
  text-decoration: none;
}

.footer-menu img {
  width: 20px;
  margin-right: 10px;
}

.footer-bottom {
  border-top: 1px solid var(--text);
  padding: 25px 0;
}

.footer-des {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.footer-bottom-child {
  display: flex;
  justify-content: center;
}

.prefix {
  width: 70px;
}

.footer-bottom-child p {
  margin: 0;
}

.roadmap img {
  width: 200px;
}

.roadmap-list img {
  width: 20px;
}

.send-query {
  right: 64px;
  bottom: 53px;
  position: absolute;
  padding: 6px 28px;
  border-radius: 4px;
  border: none;
  background: antiquewhite;
  font-family: Ubuntu;
}

.main-counter {
  max-width: 696px;
  width: 100%;
  padding: 45px 93px;
  background-color: rgba(255, 255, 255, 0.09);
  border-radius: 8px;
}

.main-counter p {
  text-align: center;
  margin-bottom: 3rem;
}

.total {
  margin-top: 3rem;
  margin-bottom: 0 !important;
  color: var(--primary);
}

.plus-sign {
  position: absolute;
  top: 8px;
  left: 8px;
}

.mobile-input {
  position: relative;
  max-width: 337px;
}

.validation {
  color: rgb(238, 52, 52);
}

.counter {
  /* border: 1px solid #fff; */
  border-radius: 5px;
  padding: 0px 40px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: baseline;
  color: white;
  margin-bottom: 40px;
}

.counter button {
  background: transparent;
  border: none;
  color: white;
}

.flex-center {
  display: flex;
  justify-content: center;
}

.image-slider {
  margin: 100px 0px;
  padding-top: 30px;
  padding-bottom: 30px;
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}

.image-slider img {
  width: 219px;
  height: 219px;
  margin: auto;
}

/* ROADMAP */
.roadmap {
  margin-top: 2rem;
}

.roadmap-meta {
  align-items: stretch;
  display: flex;
  justify-content: center;
}

.roadmap-meta .roadmap-center {
  /* background: url(../images/roadmap-dot.png); */
  background-position: top;
  background-repeat: repeat-y;
  text-align: center;
  width: 10%;
}

.roadmap-meta .phases {
  background-color: var(--secondary);
  border: 2px solid #4b0947;
  border: 2px solid var(--primary);
  color: #fff;
  color: var(--text);
}

.roadmap-meta .phases p {
  margin-bottom: 0;
  padding: 10px;
}

.roadmap-meta .roadmap-data {
  margin-bottom: 50px;
  padding: 0 30px;
  width: 70%;
}

.roadmap-box {
  background: var(--secondary);
  /* background-image: url(../images/favicon.png); */
  background-position: 100% 110%;
  background-repeat: no-repeat;
  background-size: 15%;
  border: 1px solid var(--primary);
  clip-path: polygon(95% 0, 100% 25%, 100% 100%, 0 100%, 0 0);
  color: var(--primary);
  padding: 40px 25px;
  position: relative;
  transition: all 0.5s;
  z-index: 1;
}

.roadmap-box h2,
.roadmap-box p {
  color: #fff;
}

/* ABOUT */
.module-border-wrap {
  padding: 1rem;
  position: relative;
  background: linear-gradient(to bottom, #7A04EB, #5a5a5a);
  padding: 1px;
  border-radius: 10px;
}

.module {
  background: linear-gradient(to right, #45028a 4%, #040015 35%);
  -webkit-backdrop-filter: blur(200px);
          backdrop-filter: blur(200px);
  color: white;
  padding: 2rem;
  border-radius: 10px;
}

.faq-close {
  width: 35px;
  /* cursor: pointer; */
}

.faq-content {
  width: -webkit-fill-available;
}

.faq-number {
  padding-right: 30px;
  color: #9D96A8 !important;
  font-family: ag;
}

.faq-border-wrap {
  padding: 1rem;
  position: relative;
  background: linear-gradient(to bottom, #4c0d5a, #343232);
  padding: 1px;
}

.faq {
  background: #040015;
  color: white;
  padding: 2rem;
}

.faq-border {
  border: 1px solid chartreuse;
}

.info-back-img {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
}

.info-token {
  font-size: 12px;
  text-align: center;
}

.info-price-value {
  position: absolute;
  left: 22px;
  top: 36px;
  font-family: orbitron-small;
  font-size: 15px;
}

.gold-btn {
  background: #FFCA28;
  color: #040015;
  z-index: 3;
  border: none;
  font-size: 13px;
  padding: 3px 6px;
  line-height: 23px;
}

.blue-btn {
  background: #13A5F8;
  color: white;
  z-index: 3;
  border: none;
  font-size: 13px;
  padding: 3px 6px;
  line-height: 23px;
}

.grey-btn {
  background: #CFCFCF;
  color: #040015;
  z-index: 3;
  border: none;
  font-size: 13px;
  padding: 3px 6px;
  line-height: 23px;
}

.green-btn {
  background: #00F0FF;
  color: #040015;
  z-index: 3;
  border: none;
  font-size: 13px;
  padding: 3px 6px;
  line-height: 23px;
}

.info-util {
  z-index: 3;
  margin: 0;
}

.info-target h2 {
  font-family: orbitron-small;
}

.info-target h3 {
  font-family: Ubuntu;
}

.info-target p {
  font-family: Ubuntu;
}

.howwork {
  padding: 50px;
}

.only {
  position: absolute;
  width: 148px;
  right: 14px;
  top: 76px;
}

.back-img {
  position: absolute;
}

.info-gold-btn {
  z-index: 4;
}

.info-target {
  z-index: 4;
  padding-left: 30px;
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.exclusive {
  position: absolute;
  width: 120px;
  top: 18px;
  right: 18px;
  z-index: 1000;
}

.info-price {
  z-index: 2;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.info-util {
  z-index: 2;
  font-size: 12px;
  padding: 3px;
}

.roadmap h2 {
  font-family: orbitron;
}

.break-back {
  background: rgba(181, 76, 170, 0.1607843137);
  padding: 20px;
  text-align: center;
}

.break-back-card {
  background: rgba(181, 76, 170, 0.1607843137);
  padding: 20px;
  text-align: center;
  border-radius: 10px;
}

.break-back h1 {
  font-family: orbitron-small;
  color: #B54CAA;
}

.break-back p {
  font-family: Ubuntu;
}

.break-back-card h3 {
  font-family: orbitron-small;
  color: #B54CAA;
  text-align: left;
  font-size: 20px;
}

.break-back-card p {
  font-family: Ubuntu;
  text-align: left;
  font-size: 12px;
}

.preview p {
  font-family: Ubuntu;
}

.preview h2 {
  font-family: orbitron-small;
}

.preview-center {
  width: 100%;
  /* background: url('../images/pre-back.png'); */
  background-size: cover;
  height: 400px;
  background-position: center;
}

.home-center {
  width: 100%;
  /* background: url(../images/main.png); */
  background-size: cover;
  height: 700px;
  background-position: center;
}

.profile-banner {
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  height: 120px;
  background-position: center;
}

.gold-info {
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  height: 50px;
  background-position: center;
}

.preview-top p {
  font-size: 10px;
  font-family: open-sans;
}

.preview-play p {
  font-size: 15px;
  font-family: open-sans;
}

.breakdown p {
  font-family: Ubuntu;
}

.breakdown h2 {
  font-family: orbitron-small;
}

.breakdown-center {
  width: 100%;
}

.prev-description {
  font-family: Ubuntu;
}

.roadmap p {
  font-family: Ubuntu;
}

.how2 {
  padding-bottom: 8px;
}

.how3 {
  padding-bottom: 65px;
}

.waitlist-btn {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.waitlist-btn:hover {
  transform: scale(1.2);
}

.email-input {
  width: 100%;
  font-size: 22px;
  background: none;
  font-family: Ubuntu;
  color: white;
  padding: 4px 18px;
}

.waitlist-how-btn {
  display: flex;
  margin-bottom: 60px;
  justify-content: center;
  z-index: 1000;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.waitlist-how-btn:hover {
  transform: scale(1.2);
}

.play-btn-action {
  display: flex;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.play-btn-action:hover {
  transform: scale(1.2);
}

.band {
  width: 100% !important;
  margin-bottom: 100px;
}

.profile-band {
  width: 100% !important;
  margin-top: 50px;
}

.module h1 {
  font-family: Orbitron;
}

.profile-banner {
  font-family: Orbitron;
}

.module p {
  font-family: Ubuntu;
}

.module h3 {
  font-family: Ubuntu;
}

/* FAQ */
.accordion-item {
  margin-bottom: 2rem;
}

.accordion-header {
  background-color: var(--primary);
}

.accordion-body {
  color: var(--text);
  font-size: 18px;
  line-height: 35px;
  opacity: 0.7;
}

.accordion-button {
  font-weight: 700 !important;
  color: var(--text) !important;
}

.accordion-button:focus {
  border: none !important;
  box-shadow: none !important;
}

.accordion-button:not(.collapsed) {
  background-color: rgba(255, 180, 0, 0.4) !important;
  color: var(--text) !important;
}

.accordion-button i {
  margin-right: 10px;
  font-size: 2rem;
}

.accordion-collapse {
  border: 1px solid var(--primary) !important;
}

.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.custom-logo-big {
  color: #00e1ff !important;
  font-size: 26px;
  font-family: ag;
  margin: 0px;
  padding-top: 20px;
  padding-left: 15px;
}

.custom-logo-small {
  color: #ffffff !important;
  font-size: 23px;
  font-style: italic;
  font-family: monster;
  margin: 0px;
  padding-top: 20px;
}

.home-bg {
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
  min-height: calc(100vh - 100px);
  background-position: center;
}

.mask-bg {
  min-height: calc(100vh - 100px);
}

.dashboard-bg {
  width: 100%;
}

.mask-bg {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3882352941);
  position: relative;
  overflow: hidden;
}

.login-bg {
  width: 100%;
  background-color: #2b4359;
  flex: 1 1;
}

.login-panel {
  max-width: 600px !important;
  padding: 5px;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  box-shadow: 0px 0px 31px 5px rgba(0, 0, 0, 0.42);
  padding-bottom: 70px;
  padding-top: 70px;
  margin-top: 130px !important;
  position: relative;
}

.login-title {
  font-size: 40px;
  font-weight: 500;
  font-family: ag;
  color: #00e1ff !important;
  text-align: center;
  padding-bottom: 30px;
}

.login-input {
  width: 100%;
  padding: 15px 30px;
  border-radius: 100px;
  background: linear-gradient(90deg, rgb(5, 54, 50) 0%, rgb(0, 93, 117) 100%, rgb(128, 234, 255) 100%);
  border: solid 1px rgba(3, 94, 66, 0.8117647059);
  margin-top: 20px;
  font-size: 20px;
  font-family: "Ubuntu";
  color: white;
}

.login-checkbox {
  width: 30px;
  height: 30px;
  background-color: rgb(0, 93, 117);
  border: solid 1px rgba(3, 94, 66, 0.8117647059);
}

.login-text1 {
  color: rgb(151, 149, 149);
  font-size: 18px;
  font-weight: 500;
  font-family: Ubuntu;
  text-align: end;
  text-decoration: none;
  margin-top: 10px;
  cursor: pointer;
  width: fit-content;
  float: right;
}

.login-text1:hover {
  color: rgb(128, 234, 255);
}

*::placeholder {
  /* modern browser */
  color: #959697;
}

.login-btn {
  background: linear-gradient(90deg, rgb(2, 77, 119) 0%, rgb(50, 181, 207) 51%, rgb(14, 193, 239) 100%, rgb(5, 157, 248) 100%);
  color: var(--text-white) !important;
  padding-right: 10px;
  padding-left: 35px;
  padding-top: 15px;
  padding-bottom: 15px;
  border-radius: 100px;
  text-decoration: none;
  transition: all 0.5s;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  cursor: pointer;
  font-family: Ubuntu;
  border: none;
}

.login-btn:hover {
  background-color: transparent;
  background: linear-gradient(90deg, rgb(8, 103, 156) 0%, rgb(26, 196, 230) 51%, rgb(14, 193, 239) 100%, rgb(41, 166, 241) 100%);
}

.login-text2 {
  color: rgb(151, 149, 149);
  font-size: 20px;
  font-weight: 500;
  font-family: ag;
  text-align: end;
  cursor: pointer;
  padding-right: 20px;
  padding-left: 20px;
  padding-top: 15px;
  padding-bottom: 15px;
  text-decoration: none;
}

.login-text2:hover {
  color: rgb(128, 234, 255);
}

.login-button-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  margin-top: 20px;
}

.error-text {
  color: rgba(246, 20, 20, 0.8);
  margin: 0px;
  padding-left: 10px;
}

.alert_error {
  color: #d60000;
  background: rgba(248, 248, 248, 0.1411764706);
  border: none;
  width: 70%;
}

.alert_success {
  color: #00d660;
  background: rgba(248, 248, 248, 0.1411764706);
  border: none;
  width: 70%;
}

.loading-panel {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(36, 36, 36, 0.5490196078);
}

.loading-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  height: 100%;
}

.dashboard-card {
  background-color: #1d1c2e;
  border-radius: 10px;
  overflow: hidden;
  border: solid 2px #27263d;
}

.dashboard-card-header {
  background-color: #252339;
}

.dashboard-title {
  color: rgb(220, 220, 220);
  font-size: 20px;
  font-weight: 500;
  font-family: ag;
  text-align: start;
  cursor: pointer;
  padding-right: 20px;
  padding-left: 20px;
  padding-top: 15px;
  padding-bottom: 15px;
  margin: 0px;
}

.dashboard-filter-contaier {
  padding-top: 15px;
  padding-bottom: 15px;
}

.dashboard-menu-btn {
  cursor: pointer;
}

.dashboard-menu-btn:hover {
  cursor: pointer;
  transition: all 0.2s;
  scale: 1.1;
}

.footer-bg {
  background-color: rgba(53, 53, 53, 0.4);
  margin: 0px;
}

.dashboard-modal {
  background-color: #1d1c2e;
}

.tooltip-container {
  background-color: #4b495c;
  border-radius: 5px;
  border: 1px solid #28263d;
  padding: 10px;
  opacity: 0.8;
}

.chat-height {
  height: calc(100vh - 380px) !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/style.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,YAAA;AACF;;AAEA;EACE,6CAAA;EACA,yDAAA;EACA,yBAAA;EACA,sDAAA;AACF;;AAEA;EACE,6CAAA;EACA,uCAAA;EACA,iCAAA;EACA,kBAAA;EACA,yBAAA;AACF;;AAEA;;;;;;EAME,kBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,2CAAA;AACF;;AAEA;EACE,gCAAA;EACA,kCAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;AACF;;AAIA;EACE,6BAAA;EACA,qBAAA;EACA,gCAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AADF;;AAIA;EACE,6BAAA;EACA,cAAA;EACA,sCAAA;AADF;;AAIA;EACE,6BAAA;EACA,cAAA;EACA,sCAAA;AADF;;AAOA;EACE,4HAAA;EACA,mCAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AAJF;;AAOA;EACE,6BAAA;EACA,8HAAA;AAJF;;AAOA;EACE,gCAAA;EACA,kCAAA;EACA,gCAAA;AAJF;;AAOA;EACE,kBAAA;AAJF;;AAOA;EACE,eAAA;EACA,kBAAA;AAJF;;AAOA;EACE,kDAAA;EACA,sBAAA;EACA,wBAAA;AAJF;;AAOA;EACE,gDAAA;AAJF;;AAOA;;;;;;;;;;;KAAA;AAaA;EACE,gCAAA;EACA,kBAAA;EACA,eAAA;AALF;;AAQA;EACE,UAAA;AALF;;AAQA;EACE,UAAA;AALF;;AAQA;EACE,YAAA;AALF;;AAQA;EACE,2CAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;AALF;;AAQA;EACE,6BAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AALF;;AAQA;EACE,eAAA;EACA,kBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,wBAAA;EACA,SAAA;AALF;;AAUA;EACE;IACE,WAAA;EAPF;AACF;AAUA;;;;;;;;;GAAA;AAWA;EAEE,mBAAA;EACA,kBAAA;EACA,aAAA;AATF;;AAYA;EACE,gCAAA;EACA,sBAAA;EACA,UAAA;EACA,oBAAA;AATF;;AAYA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AATF;;AAYA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,gCAAA;EACA,qBAAA;EACA,QAAA;EACA,QAAA;AATF;;AAYA;EACE,kBAAA;EACA,QAAA;AATF;;AAYA;EACE,YAAA;EACA,WAAA;AATF;;AAYA;EACE,YAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;AATF;;AAYA;EACE,mDAAA;EACA,wBAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,4BAAA;EACA,eAAA;AATF;;AAYA;EACE,YAAA;AATF;;AAYA;EACE,WAAA;AATF;;AAYA;EACE,gBAAA;AATF;;AAYA;EACE,sCAAA;AATF;;AAYA;EACE;IACE,uBAAA;EATF;EAYA;IACE,yBAAA;EAVF;AACF;AAaA;EACE,kBAAA;EACA,qBAAA;AAXF;;AAcA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;AAXF;;AAcA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAXF;;AAcA;EACE,mBAAA;AAXF;;AAcA;EACE,iBAAA;EACA,gBAAA;EACA,eAAA;AAXF;;AAcA;EACE,aAAA;AAXF;;AAcA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAXF;;AAcA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;AAXF;;AAcA;EACE,qBAAA;AAXF;;AAcA;EACE,YAAA;AAXF;;AAcA;EACE,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;AAXF;;AAcA;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,6BAAA;AAXF;;AAcA;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,gDAAA;EACA,QAAA;AAXF;;AAcA;;EAEE,aAAA;EACA,cAAA;EACA,aAAA;EACA,6BAAA;EACA,qBAAA;EACA,mBAAA;AAXF;;AAcA;EACE,gBAAA;AAXF;;AAcA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;AAXF;;AAcA;EAEE,eAAA;EACA,iBAAA;EACA,YAAA;AAZF;;AAgBA;;EAEE,gBAAA;AAbF;;AAgBA;;EAEE,YAAA;AAbF;;AAgBA;EACE,aAAA;EACA,uBAAA;EACA,gGAAA;EAIA,aAAA;EACA,6BAAA;EACA,aAAA;AAhBF;;AAmBA;EACE,+EAAA;AAhBF;;AAsBA;EACE,WAAA;AAnBF;;AAsBA;EACE,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;AAnBF;;AAsBA;EACE,uBAAA;EACA,gBAAA;EACA,eAAA;AAnBF;;AAsBA;EACE,uBAAA;EACA,eAAA;EACA,iBAAA;AAnBF;;AAsBA;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;AAnBF;;AAsBA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAnBF;;AAsBA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,uBAAA;AAnBF;;AAsBA;EACE,UAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,yBAAA;EACA,oBAAA;AAnBF;;AAsBA;EACE,YAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,eAAA;AAnBF;;AAsBA;EACE,eAAA;AAnBF;;AAsBA;EACE,YAAA;AAnBF;;AAsBA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;AAnBF;;AAsBA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAnBF;;AAsBA;EACE,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAnBF;;AAsBA;EACE,kDAAA;EACA,iBAAA;EACA,YAAA;AAnBF;;AAsBA;EACE,2BAAA;AAnBF;;AAsBA;EACE,kBAAA;EACA,UAAA;AAnBF;;AAsBA;EACE,eAAA;AAnBF;;AAsBA;EACE,kBAAA;EAEA,qBAAA;AApBF;;AAuBA;EACE,WAAA;EACA,kBAAA;AApBF;;AAuBA;EACE,iCAAA;EACA,eAAA;AApBF;;AAuBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,aAAA;EACA,uBAAA;AApBF;;AAuBA;EACE,WAAA;AApBF;;AAuBA;EACE,SAAA;AApBF;;AAuBA;EACE,YAAA;AApBF;;AAuBA;EACE,WAAA;AApBF;;AAuBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,2CAAA;EACA,kBAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,mBAAA;AApBF;;AAuBA;EAEE,gBAAA;EACA,2BAAA;EACA,qBAAA;AArBF;;AAyBA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AAtBF;;AAyBA;EACE,kBAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,uBAAA;AAtBF;;AAyBA;EACE,4BAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;AAtBF;;AAyBA;EACE,uBAAA;EACA,YAAA;EACA,YAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,uBAAA;AAtBF;;AAyBA;EAEE,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,6BAAA;EACA,8BAAA;AAvBF;;AA0BA;EACE,YAAA;EACA,aAAA;EACA,YAAA;AAvBF;;AA0BA,YAAA;AAEA;EAEE,gBAAA;AAzBF;;AA6BA;EACE,oBAAA;EACA,aAAA;EACA,uBAAA;AA1BF;;AA6BA;EACE,gDAAA;EACA,wBAAA;EACA,2BAAA;EACA,kBAAA;EACA,UAAA;AA1BF;;AA6BA;EACE,kCAAA;EACA,yBAAA;EACA,gCAAA;EACA,WAAA;EACA,kBAAA;AA1BF;;AA6BA;EACE,gBAAA;EACA,aAAA;AA1BF;;AA6BA;EACE,mBAAA;EACA,eAAA;EACA,UAAA;AA1BF;;AA6BA;EACE,4BAAA;EACA,kDAAA;EACA,8BAAA;EACA,4BAAA;EACA,oBAAA;EACA,gCAAA;EAEA,2DAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,UAAA;AA1BF;;AA6BA;;EAEE,WAAA;AA1BF;;AA6BA,UAAA;AAEA;EACE,aAAA;EACA,kBAAA;EACA,wDAAA;EACA,YAAA;EACA,mBAAA;AA3BF;;AA8BA;EACE,8DAAA;EACA,oCAAA;UAAA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AA3BF;;AA8BA;EACE,WAAA;EACA,qBAAA;AA3BF;;AA8BA;EACE,6BAAA;AA3BF;;AA8BA;EACE,mBAAA;EACA,yBAAA;EACA,eAAA;AA3BF;;AAgCA;EACE,aAAA;EACA,kBAAA;EACA,wDAAA;EACA,YAAA;AA7BF;;AAgCA;EACE,mBAAA;EACA,YAAA;EACA,aAAA;AA7BF;;AAgCA;EACE,4BAAA;AA7BF;;AAgCA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;AA7BF;;AAgCA;EACE,eAAA;EACA,kBAAA;AA7BF;;AAgCA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;AA7BF;;AAgCA;EACE,mBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA7BF;;AAgCA;EACE,mBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA7BF;;AAgCA;EACE,mBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA7BF;;AAgCA;EACE,mBAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA7BF;;AAgCA;EACE,UAAA;EACA,SAAA;AA7BF;;AAgCA;EACE,2BAAA;AA7BF;;AAgCA;EACE,mBAAA;AA7BF;;AAgCA;EACE,mBAAA;AA7BF;;AAgCA;EACE,aAAA;AA7BF;;AAgCA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AA7BF;;AAgCA;EACE,kBAAA;AA7BF;;AAgCA;EACE,UAAA;AA7BF;;AAgCA;EACE,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AA7BF;;AAgCA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;AA7BF;;AAgCA;EACE,UAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;AA7BF;;AAgCA;EACE,UAAA;EACA,eAAA;EACA,YAAA;AA7BF;;AAgCA;EACE,qBAAA;AA7BF;;AAgCA;EACE,4CAAA;EACA,aAAA;EACA,kBAAA;AA7BF;;AAgCA;EACE,4CAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AA7BF;;AAgCA;EACE,2BAAA;EACA,cAAA;AA7BF;;AAiCA;EACE,mBAAA;AA9BF;;AAiCA;EACE,2BAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA9BF;;AAiCA;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;AA9BF;;AAiCA;EACE,mBAAA;AA9BF;;AAiCA;EACE,2BAAA;AA9BF;;AAiCA;EACE,WAAA;EACA,+CAAA;EACA,sBAAA;EACA,aAAA;EACA,2BAAA;AA9BF;;AAiCA;EACE,WAAA;EACA,yCAAA;EACA,sBAAA;EACA,aAAA;EACA,2BAAA;AA9BF;;AAiCA;EACE,WAAA;EACA,mDAAA;EACA,sBAAA;EACA,aAAA;EACA,2BAAA;AA9BF;;AAiCA;EACE,WAAA;EACA,mDAAA;EACA,YAAA;EACA,2BAAA;AA9BF;;AAkCA;EACE,eAAA;EACA,sBAAA;AA/BF;;AAkCA;EACE,eAAA;EACA,sBAAA;AA/BF;;AAmCA;EACE,mBAAA;AAhCF;;AAmCA;EACE,2BAAA;AAhCF;;AAmCA;EACE,WAAA;AAhCF;;AAmCA;EACE,mBAAA;AAhCF;;AAmCA;EACE,mBAAA;AAhCF;;AAmCA;EACE,mBAAA;AAhCF;;AAmCA;EACE,oBAAA;AAhCF;;AAmCA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;AAhCF;;AAmCA;EACE,qBAAA;AAhCF;;AAmCA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AAhCF;;AAmCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,gCAAA;AAhCF;;AAmCA;EACE,qBAAA;AAhCF;;AAmCA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gCAAA;AAhCF;;AAmCA;EACE,qBAAA;AAhCF;;AAmCA;EACE,sBAAA;EACA,oBAAA;AAhCF;;AAmCA;EACE,sBAAA;EACA,gBAAA;AAhCF;;AAmCA;EACE,qBAAA;AAhCF;;AAmCA;EACE,qBAAA;AAhCF;;AAmCA;EACE,mBAAA;AAhCF;;AAmCA;EACE,mBAAA;AAhCF;;AAmCA,QAAA;AAEA;EAEE,mBAAA;AAlCF;;AAuCA;EAEE,gCAAA;AArCF;;AAyCA;EAEE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AAvCF;;AA2CA;EAEE,2BAAA;EACA,6BAAA;AAzCF;;AA6CA;EAEE,uBAAA;EACA,2BAAA;AA3CF;;AA+CA;EAEE,mDAAA;EACA,6BAAA;AA7CF;;AAiDA;EAEE,kBAAA;EACA,eAAA;AA/CF;;AAmDA;EAEE,2CAAA;AAjDF;;AAqDA;EACE,oCAAA;EACA,qCAAA;AAlDF;;AAqDA;EACE,yBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAlDF;;AAqDA;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,iBAAA;AAlDF;;AAqDA;EACE,WAAA;EACA,mDAAA;EACA,sBAAA;EACA,+BAAA;EACA,2BAAA;AAlDF;;AAqDA;EACE,+BAAA;AAlDF;;AAqDA;EACE,WAAA;AAlDF;;AAqDA;EACE,WAAA;EACA,YAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;AAlDF;;AAqDA;EACE,WAAA;EACA,yBAAA;EACA,SAAA;AAlDF;;AAqDA;EACE,2BAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,gDAAA;EACA,oBAAA;EACA,iBAAA;EACA,4BAAA;EACA,kBAAA;AAlDF;;AAqDA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;AAlDF;;AAqDA;EACE,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,oGAAA;EACA,+CAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;AAlDF;;AAqDA;EACE,WAAA;EACA,YAAA;EACA,iCAAA;EACA,+CAAA;AAlDF;;AAqDA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AAlDF;;AAqDA;EACE,yBAAA;AAlDF;;AA+EA;EACE,mBAAA;EACA,cAAA;AAlDF;;AAqDA;EACE,4HAAA;EACA,mCAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AAlDF;;AAqDA;EACE,6BAAA;EACA,8HAAA;AAlDF;;AAqDA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;AAlDF;;AAqDA;EACE,yBAAA;AAlDF;;AAqDA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAlDF;;AAqDA;EACE,6BAAA;EACA,WAAA;EACA,kBAAA;AAlDF;;AAqDA;EACE,cAAA;EACA,6CAAA;EACA,YAAA;EACA,UAAA;AAlDF;;AAqDA;EACE,cAAA;EACA,6CAAA;EACA,YAAA;EACA,UAAA;AAlDF;;AAsDA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;AAnDF;;AAsDA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AAnDF;;AAsDA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AAnDF;;AAsDA;EACE,yBAAA;AAnDF;;AAsDA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;AAnDF;;AAsDA;EACE,iBAAA;EACA,oBAAA;AAnDF;;AAsDA;EACE,eAAA;AAnDF;;AAsDA;EACE,eAAA;EACA,oBAAA;EACA,UAAA;AAnDF;;AAsDA;EACE,uCAAA;EACA,WAAA;AAnDF;;AAsDA;EACE,yBAAA;AAnDF;;AAsDA;EACE,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,YAAA;AAnDF;;AAsDA;EACE,sCAAA;AAnDF","sourcesContent":[":root {\r\n  --primary: #ffb400;\r\n  --secondary: #0d0d2b;\r\n  --text-dark: #000;\r\n  --text: #fff;\r\n}\r\n\r\nbody {\r\n  background-color: var(--secondary) !important;\r\n  background-image: url(\"../images/topback.svg\");\r\n  background-color: #040015;\r\n  /* font-family: \"Montserrat\", sans-serif !important; */\r\n}\r\n\r\n.main {\r\n  background-position: center center !important;\r\n  background-repeat: no-repeat !important;\r\n  background-size: cover !important;\r\n  overflow-x: hidden;\r\n  background-color: #040015;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  color: var(--text);\r\n}\r\n\r\np {\r\n  color: var(--text);\r\n}\r\n\r\nimg {\r\n  width: 100%;\r\n}\r\n\r\na:hover {\r\n  color: #00e1ff !important;\r\n}\r\n\r\n.modal-header {\r\n  border: none !important;\r\n}\r\n\r\n.modal-body h5 {\r\n  color: var(--text-dark);\r\n  text-align: center;\r\n}\r\n\r\n.modal-content {\r\n  background-color: var(--primary) !important;\r\n}\r\n\r\n.custom-btn {\r\n  background-color: var(--primary);\r\n  color: var(--text-dark) !important;\r\n  padding: 16px 36px;\r\n  border-radius: 6px;\r\n  text-decoration: none;\r\n  transition: all 0.5s;\r\n  font-weight: 600;\r\n  font-size: 18px;\r\n  text-align: center;\r\n  border: 1px solid var(--primary);\r\n  cursor: pointer;\r\n  font-family: Ubuntu;\r\n  z-index: 1;\r\n}\r\n\r\n\r\n\r\n.custom-tp {\r\n  background-color: transparent;\r\n  color: var(--primary);\r\n  border: 1px solid var(--primary);\r\n  padding: 16px 36px;\r\n  border-radius: 6px;\r\n  text-decoration: none;\r\n  transition: all 0.5s;\r\n  font-weight: 600;\r\n  font-size: 18px;\r\n  text-align: center;\r\n}\r\n\r\n.custom-btn:hover {\r\n  background-color: transparent;\r\n  color: #00e1ff;\r\n  /* border: 1px solid var(--primary); */\r\n}\r\n\r\n.custom-nav-btn:hover {\r\n  background-color: transparent;\r\n  color: #00e1ff;\r\n  /* border: 1px solid var(--primary); */\r\n}\r\n\r\n\r\n\r\n\r\n.signup-btn {\r\n  background: linear-gradient(90deg, rgba(2,77,119,1) 0%, rgba(50,181,207,1) 51%, rgba(14,193,239,1) 100%, rgba(5,157,248,1) 100%);\r\n  color: var(--text-white) !important;\r\n  padding-right: 10px;\r\n  padding-left: 35px;\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n  border-radius: 100px;\r\n  text-decoration: none;\r\n  transition: all 0.5s;\r\n  font-weight: 600;\r\n  font-size: 18px;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  font-family: Ubuntu;\r\n  border: none;\r\n}\r\n\r\n.signup-btn:hover {\r\n  background-color: transparent;\r\n  background: linear-gradient(90deg, rgba(8,103,156,1) 0%, rgba(26,196,230,1) 51%, rgba(14,193,239,1) 100%, rgba(41,166,241,1) 100%);\r\n}\r\n\r\n.custom-tp:hover {\r\n  background-color: var(--primary);\r\n  color: var(--text-dark) !important;\r\n  border: 1px solid var(--primary);\r\n}\r\n\r\n.btn-grp a {\r\n  margin-right: 20px;\r\n}\r\n\r\n.section-padding {\r\n  padding: 5rem 0;\r\n  position: relative;\r\n}\r\n\r\n.section-bg {\r\n  /* background-image: url(../images/image-8.png); */\r\n  background-size: cover;\r\n  background-position: top;\r\n}\r\n\r\n.nav-bg {\r\n  background-color: #1d192c8c;\r\n}\r\n\r\n/* \r\n.section-bg::after{\r\n\r\n  content: \"\";\r\n  position: absolute;\r\n  display: inline-block;\r\n  width: 100%;\r\n  background-image: linear-gradient(180deg,#0000,var(--secondary));\r\n  height: 100px;\r\n\r\n  \r\n  } */\r\n\r\n.top-header {\r\n  background-color: var(--primary);\r\n  text-align: center;\r\n  padding: 15px 0;\r\n}\r\n\r\n.middle-back {\r\n  z-index: 1;\r\n}\r\n\r\n.bottom-back {\r\n  z-index: 1;\r\n}\r\n\r\n.logo {\r\n  height: 37px;\r\n}\r\n\r\n.nav-custom {\r\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\r\n  color: var(--text);\r\n  z-index: 9999;\r\n  height: 90px;\r\n  padding: 0 3rem;\r\n}\r\n\r\n.navbar-light .navbar-nav .nav-link {\r\n  color: var(--text) !important;\r\n  font-size: 16px;\r\n  line-height: 24px;\r\n  font-family: Ubuntu;\r\n}\r\n\r\n.nav-item {\r\n  padding: 0 20px;\r\n  position: relative;\r\n}\r\n\r\n.navbar-nav {\r\n  align-items: center;\r\n}\r\n\r\n.nav-link {\r\n  position: relative;\r\n}\r\n\r\n.nav-link::after {\r\n  content: \"\";\r\n  background-color: var(--primary);\r\n  position: absolute;\r\n  height: 2px;\r\n  width: 0;\r\n  left: 0;\r\n  transition: 0.5s ease-in;\r\n  bottom: 0;\r\n}\r\n\r\n\r\n\r\n@media screen and (min-width: 480px) {\r\n  .nav-link:hover::after {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n/* .active::after {\r\n  content: \"\";\r\n  background-color: var(--primary);\r\n  position: absolute;\r\n  height: 2px;\r\n  width: 100%;\r\n  left: 0;\r\n  transition: 0.5s ease-in;\r\n  bottom: 0;\r\n} */\r\n\r\n.main-title {\r\n  display: flex;\r\n  align-items: center;\r\n  position: relative;\r\n  display: flex;\r\n}\r\n\r\n.main-title hr {\r\n  background-color: var(--primary);\r\n  height: 2px !important;\r\n  width: 10%;\r\n  margin: 0 !important;\r\n}\r\n\r\n.main-title p {\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  position: relative;\r\n  padding-left: 55px;\r\n}\r\n\r\n.main-title p::before {\r\n  position: absolute;\r\n  content: \"\";\r\n  width: 50px;\r\n  height: 2px;\r\n  background-color: var(--primary);\r\n  display: inline-block;\r\n  left: 0%;\r\n  top: 50%;\r\n}\r\n\r\n.stars {\r\n  position: absolute;\r\n  right: 0;\r\n}\r\n\r\n.stars img:nth-child(1) {\r\n  height: 64px;\r\n  width: 64px;\r\n}\r\n\r\n.stars img:nth-child(2) {\r\n  height: 34px;\r\n  width: 34px;\r\n  top: 50px;\r\n  right: -100px;\r\n  position: absolute;\r\n}\r\n\r\n.main-img {\r\n  /* background-image: url(../images/image\\ 2.png); */\r\n  background-size: contain;\r\n  background-position: 100% 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  background-repeat: no-repeat;\r\n  padding: 30px 0;\r\n}\r\n\r\n.main-img img {\r\n  width: 500px;\r\n}\r\n\r\n.line-grid {\r\n  width: 100%;\r\n}\r\n\r\n.main-gif img {\r\n  max-width: 470px;\r\n}\r\n\r\n.rotate {\r\n  animation: rotation 8s infinite linear;\r\n}\r\n\r\n@keyframes rotation {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  to {\r\n    transform: rotate(359deg);\r\n  }\r\n}\r\n\r\n.title {\r\n  text-align: center;\r\n  font-family: orbitron;\r\n}\r\n\r\n.sub-title {\r\n  font-family: Ubuntu;\r\n  color: #dfdfdf;\r\n  font-size: 30px;\r\n}\r\n\r\n.home-title h1 {\r\n  font-weight: 500;\r\n  font-family: ag;\r\n  color: #00e1ff;\r\n}\r\n\r\n.title p {\r\n  letter-spacing: 2px;\r\n}\r\n\r\n.download-btn {\r\n  padding-top: 50px;\r\n  max-width: 200px;\r\n  cursor: pointer;\r\n}\r\n\r\n.download-btn:hover {\r\n  opacity: 0.73;\r\n}\r\n\r\n.title h1 {\r\n  font-size: 50px;\r\n  line-height: 75px;\r\n  text-align: left;\r\n}\r\n\r\n.title h2 {\r\n  font-weight: 500;\r\n  font-size: 40px;\r\n  letter-spacing: 2px;\r\n}\r\n\r\n.title h1 span {\r\n  color: var(--primary);\r\n}\r\n\r\n.heythere {\r\n  width: 600px;\r\n}\r\n\r\n.aboutus {\r\n  font-family: Ubuntu;\r\n  width: -webkit-fill-available;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.stick-icon {\r\n  width: 150px;\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translate(0, -50%);\r\n}\r\n\r\n.stick-icon-right {\r\n  width: 150px;\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translate(-10px, 10px) rotate(272deg);\r\n  right: 0;\r\n}\r\n\r\n.main-box,\r\n.main-box-lg {\r\n  padding: 20px;\r\n  margin: 43px 0;\r\n  display: flex;\r\n  justify-content: space-around;\r\n  align-items: baseline;\r\n  flex-direction: row;\r\n}\r\n\r\n.main-button {\r\n  margin-top: 50px;\r\n}\r\n\r\n.main-box p {\r\n  font-size: 18px;\r\n  line-height: 27px;\r\n  opacity: 0.7;\r\n}\r\n\r\n.main-box-lg p {\r\n\r\n  font-size: 28px;\r\n  line-height: 37px;\r\n  opacity: 0.7;\r\n\r\n}\r\n\r\n.main-box span,\r\n.main-box-lg span {\r\n  font-weight: 900;\r\n}\r\n\r\n.main-box a,\r\n.main-box-lg a {\r\n  color: white;\r\n}\r\n\r\n.info-box {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  background: linear-gradient(112deg,\r\n      #000000 4.11%,\r\n      #ffffff 4.11%,\r\n      rgba(255, 255, 255, 0.5) 100%);\r\n  padding: 20px;\r\n  border: 1px solid var(--text);\r\n  height: 184px;\r\n}\r\n\r\n.info-box-yellow {\r\n  background: linear-gradient(112deg,\r\n      #000000 4.11%,\r\n      #ffb400 4.11%,\r\n      #ffb400 100%);\r\n}\r\n\r\n.info-box img {\r\n  width: 50px;\r\n}\r\n\r\n.info-img {\r\n  background-color: var(--text);\r\n  border-radius: 50%;\r\n  padding: 10px;\r\n  margin-right: 10px;\r\n}\r\n\r\n.info-box-details {\r\n  display: flex;\r\n  color: var(--text-dark);\r\n  flex-direction: column;\r\n}\r\n\r\n.info-box-details h3 {\r\n  color: var(--text-dark);\r\n  font-weight: 600;\r\n  font-size: 48px;\r\n}\r\n\r\n.info-box-details p {\r\n  color: var(--text-dark);\r\n  font-size: 18px;\r\n  line-height: 27px;\r\n}\r\n\r\n.sm-title {\r\n  color: var(--primary);\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  margin: 0;\r\n}\r\n\r\n.lg-title {\r\n  font-weight: 600;\r\n  font-size: 47px;\r\n  line-height: 58px;\r\n}\r\n\r\n.sm-des {\r\n  font-size: 16px;\r\n  line-height: 29px;\r\n  opacity: 0.7;\r\n}\r\n\r\n.social-btn {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.social-btn ul {\r\n  padding: 0;\r\n  display: flex;\r\n  list-style: none;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.social-btn img {\r\n  width: 60px;\r\n  height: 60px;\r\n  margin-right: 15px;\r\n}\r\n\r\n.profile-name {\r\n  color: #A77032 !important;\r\n  font-family: monster;\r\n}\r\n\r\n.section-img {\r\n  width: 400px;\r\n}\r\n\r\n.img-grp {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.img-grp>div {\r\n  flex-basis: 50%;\r\n}\r\n\r\n.img-grp img {\r\n  width: 200px;\r\n}\r\n\r\n.subscribe {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.subscribe input:not(input[type=\"submit\"]) {\r\n  width: 100%;\r\n  border-radius: 32px;\r\n  padding: 15px;\r\n}\r\n\r\n.subscribe input::placeholder {\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n  line-height: 22px;\r\n}\r\n\r\n.submit-ab {\r\n  border: none;\r\n  background-color: var(--primary);\r\n  position: absolute;\r\n  right: 5px;\r\n  width: 25%;\r\n  border-radius: 32px;\r\n  padding: 10px 10px;\r\n  font-weight: 500;\r\n  font-size: 18px;\r\n}\r\n\r\nfooter {\r\n  background-color: #ffffff08;\r\n  padding-top: 50px;\r\n  z-index: 999;\r\n}\r\n\r\n.footer-liks {\r\n  margin-top: 5rem !important;\r\n}\r\n\r\n.footer-menu {\r\n  color: var(--text);\r\n  padding: 0;\r\n}\r\n\r\n.footer-menu li {\r\n  padding: 12px 0;\r\n}\r\n\r\n.footer-menu a {\r\n  color: var(--text);\r\n\r\n  text-decoration: none;\r\n}\r\n\r\n.footer-menu img {\r\n  width: 20px;\r\n  margin-right: 10px;\r\n}\r\n\r\n.footer-bottom {\r\n  border-top: 1px solid var(--text);\r\n  padding: 25px 0;\r\n}\r\n\r\n.footer-des {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.footer-bottom-child {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.prefix {\r\n  width: 70px;\r\n}\r\n\r\n.footer-bottom-child p {\r\n  margin: 0;\r\n}\r\n\r\n.roadmap img {\r\n  width: 200px;\r\n}\r\n\r\n.roadmap-list img {\r\n  width: 20px;\r\n}\r\n\r\n.send-query {\r\n  right: 64px;\r\n  bottom: 53px;\r\n  position: absolute;\r\n  padding: 6px 28px;\r\n  border-radius: 4px;\r\n  border: none;\r\n  background: antiquewhite;\r\n  font-family: Ubuntu;\r\n}\r\n\r\n.main-counter {\r\n  max-width: 696px;\r\n  width: 100%;\r\n  padding: 45px 93px;\r\n  background-color: rgba(255, 255, 255, 0.09);\r\n  border-radius: 8px;\r\n}\r\n\r\n.main-counter p {\r\n  text-align: center;\r\n  margin-bottom: 3rem;\r\n}\r\n\r\n.total {\r\n\r\n  margin-top: 3rem;\r\n  margin-bottom: 0 !important;\r\n  color: var(--primary);\r\n\r\n}\r\n\r\n.plus-sign {\r\n  position: absolute;\r\n  top: 8px;\r\n  left: 8px;\r\n}\r\n\r\n.mobile-input {\r\n  position: relative;\r\n  max-width: 337px;\r\n}\r\n\r\n.validation {\r\n  color: rgb(238, 52, 52);\r\n}\r\n\r\n.counter {\r\n  /* border: 1px solid #fff; */\r\n  border-radius: 5px;\r\n  padding: 0px 40px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: baseline;\r\n  color: white;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.counter button {\r\n  background: transparent;\r\n  border: none;\r\n  color: white;\r\n}\r\n\r\n.flex-center {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.image-slider {\r\n\r\n  margin: 100px 0px;\r\n  padding-top: 30px;\r\n  padding-bottom: 30px;\r\n  padding-left: 3rem !important;\r\n  padding-right: 3rem !important;\r\n}\r\n\r\n.image-slider img {\r\n  width: 219px;\r\n  height: 219px;\r\n  margin: auto;\r\n}\r\n\r\n/* ROADMAP */\r\n\r\n.roadmap {\r\n\r\n  margin-top: 2rem;\r\n\r\n}\r\n\r\n.roadmap-meta {\r\n  align-items: stretch;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.roadmap-meta .roadmap-center {\r\n  /* background: url(../images/roadmap-dot.png); */\r\n  background-position: top;\r\n  background-repeat: repeat-y;\r\n  text-align: center;\r\n  width: 10%;\r\n}\r\n\r\n.roadmap-meta .phases {\r\n  background-color: var(--secondary);\r\n  border: 2px solid #4b0947;\r\n  border: 2px solid var(--primary);\r\n  color: #fff;\r\n  color: var(--text);\r\n}\r\n\r\n.roadmap-meta .phases p {\r\n  margin-bottom: 0;\r\n  padding: 10px;\r\n}\r\n\r\n.roadmap-meta .roadmap-data {\r\n  margin-bottom: 50px;\r\n  padding: 0 30px;\r\n  width: 70%;\r\n}\r\n\r\n.roadmap-box {\r\n  background: var(--secondary);\r\n  /* background-image: url(../images/favicon.png); */\r\n  background-position: 100% 110%;\r\n  background-repeat: no-repeat;\r\n  background-size: 15%;\r\n  border: 1px solid var(--primary);\r\n  -webkit-clip-path: polygon(95% 0, 100% 25%, 100% 100%, 0 100%, 0 0);\r\n  clip-path: polygon(95% 0, 100% 25%, 100% 100%, 0 100%, 0 0);\r\n  color: var(--primary);\r\n  padding: 40px 25px;\r\n  position: relative;\r\n  transition: all .5s;\r\n  z-index: 1;\r\n}\r\n\r\n.roadmap-box h2,\r\n.roadmap-box p {\r\n  color: #fff;\r\n}\r\n\r\n/* ABOUT */\r\n\r\n.module-border-wrap {\r\n  padding: 1rem;\r\n  position: relative;\r\n  background: linear-gradient(to bottom, #7A04EB, #5a5a5a);\r\n  padding: 1px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.module {\r\n  background: linear-gradient(to right, #45028a 4%, #040015 35%);\r\n  backdrop-filter: blur(200px);\r\n  color: white;\r\n  padding: 2rem;\r\n  border-radius: 10px;\r\n}\r\n\r\n.faq-close {\r\n  width: 35px;\r\n  /* cursor: pointer; */\r\n}\r\n\r\n.faq-content {\r\n  width: -webkit-fill-available;\r\n}\r\n\r\n.faq-number {\r\n  padding-right: 30px;\r\n  color: #9D96A8 !important;\r\n  font-family: ag;\r\n}\r\n\r\n\r\n\r\n.faq-border-wrap {\r\n  padding: 1rem;\r\n  position: relative;\r\n  background: linear-gradient(to bottom, #4c0d5a, #343232);\r\n  padding: 1px;\r\n}\r\n\r\n.faq {\r\n  background: #040015;\r\n  color: white;\r\n  padding: 2rem;\r\n}\r\n\r\n.faq-border {\r\n  border: 1px solid chartreuse;\r\n}\r\n\r\n.info-back-img {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  height: 100%;\r\n}\r\n\r\n.info-token {\r\n  font-size: 12px;\r\n  text-align: center;\r\n}\r\n\r\n.info-price-value {\r\n  position: absolute;\r\n  left: 22px;\r\n  top: 36px;\r\n  font-family: orbitron-small;\r\n  font-size: 15px;\r\n}\r\n\r\n.gold-btn {\r\n  background: #FFCA28;\r\n  color: #040015;\r\n  z-index: 3;\r\n  border: none;\r\n  font-size: 13px;\r\n  padding: 3px 6px;\r\n  line-height: 23px;\r\n}\r\n\r\n.blue-btn {\r\n  background: #13A5F8;\r\n  color: white;\r\n  z-index: 3;\r\n  border: none;\r\n  font-size: 13px;\r\n  padding: 3px 6px;\r\n  line-height: 23px;\r\n}\r\n\r\n.grey-btn {\r\n  background: #CFCFCF;\r\n  color: #040015;\r\n  z-index: 3;\r\n  border: none;\r\n  font-size: 13px;\r\n  padding: 3px 6px;\r\n  line-height: 23px;\r\n}\r\n\r\n.green-btn {\r\n  background: #00F0FF;\r\n  color: #040015;\r\n  z-index: 3;\r\n  border: none;\r\n  font-size: 13px;\r\n  padding: 3px 6px;\r\n  line-height: 23px;\r\n}\r\n\r\n.info-util {\r\n  z-index: 3;\r\n  margin: 0;\r\n}\r\n\r\n.info-target h2 {\r\n  font-family: orbitron-small;\r\n}\r\n\r\n.info-target h3 {\r\n  font-family: Ubuntu;\r\n}\r\n\r\n.info-target p {\r\n  font-family: Ubuntu;\r\n}\r\n\r\n.howwork {\r\n  padding: 50px;\r\n}\r\n\r\n.only {\r\n  position: absolute;\r\n  width: 148px;\r\n  right: 14px;\r\n  top: 76px;\r\n}\r\n\r\n.back-img {\r\n  position: absolute;\r\n}\r\n\r\n.info-gold-btn {\r\n  z-index: 4;\r\n}\r\n\r\n.info-target {\r\n  z-index: 4;\r\n  padding-left: 30px;\r\n  padding-top: 30px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n}\r\n\r\n.exclusive {\r\n  position: absolute;\r\n  width: 120px;\r\n  top: 18px;\r\n  right: 18px;\r\n  z-index: 1000;\r\n}\r\n\r\n.info-price {\r\n  z-index: 2;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n}\r\n\r\n.info-util {\r\n  z-index: 2;\r\n  font-size: 12px;\r\n  padding: 3px;\r\n}\r\n\r\n.roadmap h2 {\r\n  font-family: orbitron;\r\n}\r\n\r\n.break-back {\r\n  background: #b54caa29;\r\n  padding: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.break-back-card {\r\n  background: #b54caa29;\r\n  padding: 20px;\r\n  text-align: center;\r\n  border-radius: 10px;\r\n}\r\n\r\n.break-back h1 {\r\n  font-family: orbitron-small;\r\n  color: #B54CAA;\r\n}\r\n\r\n\r\n.break-back p {\r\n  font-family: Ubuntu;\r\n}\r\n\r\n.break-back-card h3 {\r\n  font-family: orbitron-small;\r\n  color: #B54CAA;\r\n  text-align: left;\r\n  font-size: 20px;\r\n}\r\n\r\n.break-back-card p {\r\n  font-family: Ubuntu;\r\n  text-align: left;\r\n  font-size: 12px;\r\n}\r\n\r\n.preview p {\r\n  font-family: Ubuntu;\r\n}\r\n\r\n.preview h2 {\r\n  font-family: orbitron-small;\r\n}\r\n\r\n.preview-center {\r\n  width: 100%;\r\n  /* background: url('../images/pre-back.png'); */\r\n  background-size: cover;\r\n  height: 400px;\r\n  background-position: center;\r\n}\r\n\r\n.home-center {\r\n  width: 100%;\r\n  /* background: url(../images/main.png); */\r\n  background-size: cover;\r\n  height: 700px;\r\n  background-position: center;\r\n}\r\n\r\n.profile-banner {\r\n  width: 100%;\r\n  background: url('../images/royalty-banner.svg');\r\n  background-size: cover;\r\n  height: 120px;\r\n  background-position: center;\r\n}\r\n\r\n.gold-info {\r\n  width: 100%;\r\n  background: url('../images/gold.svg');\r\n  height: 50px;\r\n  background-position: center;\r\n}\r\n\r\n\r\n.preview-top p {\r\n  font-size: 10px;\r\n  font-family: open-sans;\r\n}\r\n\r\n.preview-play p {\r\n  font-size: 15px;\r\n  font-family: open-sans;\r\n}\r\n\r\n\r\n.breakdown p {\r\n  font-family: Ubuntu;\r\n}\r\n\r\n.breakdown h2 {\r\n  font-family: orbitron-small;\r\n}\r\n\r\n.breakdown-center {\r\n  width: 100%;\r\n}\r\n\r\n.prev-description {\r\n  font-family: Ubuntu;\r\n}\r\n\r\n.roadmap p {\r\n  font-family: Ubuntu;\r\n}\r\n\r\n.how2 {\r\n  padding-bottom: 8px;\r\n}\r\n\r\n.how3 {\r\n  padding-bottom: 65px;\r\n}\r\n\r\n.waitlist-btn {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 40px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.waitlist-btn:hover {\r\n  transform: scale(1.2);\r\n}\r\n\r\n.email-input {\r\n  width: 100%;\r\n  font-size: 22px;\r\n  background: none;\r\n  font-family: Ubuntu;\r\n  color: white;\r\n  padding: 4px 18px;\r\n}\r\n\r\n.waitlist-how-btn {\r\n  display: flex;\r\n  margin-bottom: 60px;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.waitlist-how-btn:hover {\r\n  transform: scale(1.2);\r\n}\r\n\r\n.play-btn-action {\r\n  display: flex;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.play-btn-action:hover {\r\n  transform: scale(1.2);\r\n}\r\n\r\n.band {\r\n  width: 100% !important;\r\n  margin-bottom: 100px;\r\n}\r\n\r\n.profile-band {\r\n  width: 100% !important;\r\n  margin-top: 50px;\r\n}\r\n\r\n.module h1 {\r\n  font-family: Orbitron;\r\n}\r\n\r\n.profile-banner {\r\n  font-family: Orbitron;\r\n}\r\n\r\n.module p {\r\n  font-family: Ubuntu;\r\n}\r\n\r\n.module h3 {\r\n  font-family: Ubuntu;\r\n}\r\n\r\n/* FAQ */\r\n\r\n.accordion-item {\r\n\r\n  margin-bottom: 2rem;\r\n\r\n\r\n}\r\n\r\n.accordion-header {\r\n\r\n  background-color: var(--primary);\r\n\r\n}\r\n\r\n.accordion-body {\r\n\r\n  color: var(--text);\r\n  font-size: 18px;\r\n  line-height: 35px;\r\n  opacity: 0.7;\r\n\r\n}\r\n\r\n.accordion-button {\r\n\r\n  font-weight: 700 !important;\r\n  color: var(--text) !important;\r\n\r\n}\r\n\r\n.accordion-button:focus {\r\n\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n\r\n}\r\n\r\n.accordion-button:not(.collapsed) {\r\n\r\n  background-color: #ffb40066 !important;\r\n  color: var(--text) !important;\r\n\r\n}\r\n\r\n.accordion-button i {\r\n\r\n  margin-right: 10px;\r\n  font-size: 2rem;\r\n\r\n}\r\n\r\n.accordion-collapse {\r\n\r\n  border: 1px solid var(--primary) !important;\r\n\r\n}\r\n\r\n.accordion-item:first-of-type .accordion-button {\r\n  border-top-left-radius: 0 !important;\r\n  border-top-right-radius: 0 !important;\r\n}\r\n\r\n.custom-logo-big {\r\n  color: #00e1ff !important;\r\n  font-size: 26px;\r\n  font-family: ag;\r\n  margin: 0px;\r\n  padding-top: 20px;\r\n  padding-left: 15px;\r\n}\r\n\r\n.custom-logo-small {\r\n  color: #ffffff !important;\r\n  font-size: 23px;\r\n  font-style: italic;\r\n  font-family: monster;\r\n  margin: 0px;\r\n  padding-top: 20px;\r\n}\r\n\r\n.home-bg {\r\n  width: 100%;\r\n  background: url('../images/bg-chat.png');\r\n  background-size: cover;\r\n  min-height: calc(100vh - 100px);\r\n  background-position: center;\r\n}\r\n\r\n.mask-bg {\r\n  min-height: calc(100vh - 100px);\r\n}\r\n\r\n.dashboard-bg {\r\n  width: 100%;\r\n}\r\n\r\n.mask-bg {\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: #00000063;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.login-bg {\r\n  width: 100%;\r\n  background-color: #2b4359;\r\n  flex: 1;\r\n}\r\n\r\n.login-panel {\r\n  max-width: 600px !important;\r\n  padding: 5px;\r\n  background-color: #00000066;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 15px;\r\n  -webkit-box-shadow: 0px 0px 31px 5px rgba(0, 0, 0, 0.42);\r\n  box-shadow: 0px 0px 31px 5px rgba(0, 0, 0, 0.42);\r\n  padding-bottom: 70px;\r\n  padding-top: 70px;\r\n  margin-top: 130px !important;\r\n  position: relative;\r\n}\r\n\r\n.login-title {\r\n  font-size: 40px;\r\n  font-weight: 500;\r\n  font-family: ag;\r\n  color: #00e1ff !important;\r\n  text-align: center;\r\n  padding-bottom: 30px;\r\n}\r\n\r\n.login-input {\r\n  width: 100%;\r\n  padding: 15px 30px;\r\n  border-radius: 100px;\r\n  background: linear-gradient(90deg, rgba(5, 54, 50, 1) 0%, rgba(0, 93, 117, 1) 100%, rgba(128, 234, 255, 1) 100%);\r\n  border: solid 1px #035e42cf;\r\n  margin-top: 20px;\r\n  font-size: 20px;\r\n  font-family: 'Ubuntu';\r\n  color: white;\r\n}\r\n\r\n.login-checkbox {\r\n  width: 30px;\r\n  height: 30px;\r\n  background-color: rgba(0, 93, 117, 1);\r\n  border: solid 1px #035e42cf;\r\n}\r\n\r\n.login-text1 {\r\n  color: rgb(151, 149, 149);\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  font-family: Ubuntu;\r\n  text-align: end;\r\n  text-decoration: none;\r\n  margin-top: 10px;\r\n  cursor: pointer;\r\n  width: fit-content;\r\n  float: right;\r\n}\r\n\r\n.login-text1:hover {\r\n  color: rgba(128, 234, 255, 1);\r\n}\r\n\r\n*::-webkit-input-placeholder {\r\n  color: #959697;\r\n}\r\n\r\n*:-moz-placeholder {\r\n  /* FF 4-18 */\r\n  color: #959697;\r\n  opacity: 1;\r\n}\r\n\r\n*::-moz-placeholder {\r\n  /* FF 19+ */\r\n  color: #959697;\r\n  opacity: 1;\r\n}\r\n\r\n*:-ms-input-placeholder {\r\n  /* IE 10+ */\r\n  color: #959697;\r\n}\r\n\r\n*::-ms-input-placeholder {\r\n  /* Microsoft Edge */\r\n  color: #959697;\r\n}\r\n\r\n*::placeholder {\r\n  /* modern browser */\r\n  color: #959697;\r\n}\r\n\r\n.login-btn {\r\n  background: linear-gradient(90deg, rgba(2,77,119,1) 0%, rgba(50,181,207,1) 51%, rgba(14,193,239,1) 100%, rgba(5,157,248,1) 100%);\r\n  color: var(--text-white) !important;\r\n  padding-right: 10px;\r\n  padding-left: 35px;\r\n  padding-top: 15px;\r\n  padding-bottom: 15px;\r\n  border-radius: 100px;\r\n  text-decoration: none;\r\n  transition: all 0.5s;\r\n  font-weight: 600;\r\n  font-size: 18px;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  font-family: Ubuntu;\r\n  border: none;\r\n}\r\n\r\n.login-btn:hover {\r\n  background-color: transparent;\r\n  background: linear-gradient(90deg, rgba(8,103,156,1) 0%, rgba(26,196,230,1) 51%, rgba(14,193,239,1) 100%, rgba(41,166,241,1) 100%);\r\n}\r\n\r\n.login-text2 {\r\n  color: rgb(151, 149, 149);\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n  font-family: ag;\r\n  text-align: end;\r\n  cursor: pointer;\r\n  padding-right: 20px;\r\n  padding-left: 20px;\r\n  padding-top: 15px;\r\n  padding-bottom: 15px;\r\n  text-decoration: none;\r\n}\r\n\r\n.login-text2:hover {\r\n  color: rgba(128, 234, 255, 1);\r\n}\r\n\r\n.login-button-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  align-items: center;\r\n  margin-top: 20px;\r\n}\r\n\r\n.error-text {\r\n  color: rgba(246, 20, 20, 0.8);\r\n  margin: 0px;\r\n  padding-left: 10px;\r\n}\r\n\r\n.alert_error {\r\n  color: #d60000;\r\n  background: #f8f8f824;\r\n  border: none;\r\n  width: 70%;\r\n}\r\n\r\n.alert_success {\r\n  color: #00d660;\r\n  background: #f8f8f824;\r\n  border: none;\r\n  width: 70%;\r\n}\r\n\r\n\r\n.loading-panel {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: #2424248c;\r\n}\r\n\r\n.loading-bar {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 10000;\r\n  height: 100%;\r\n}\r\n\r\n.dashboard-card {\r\n  background-color: #1d1c2e;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  border: solid 2px #27263d;\r\n}\r\n\r\n.dashboard-card-header {\r\n  background-color: #252339;\r\n}\r\n\r\n.dashboard-title {\r\n  color: rgb(220, 220, 220);\r\n  font-size: 20px;\r\n  font-weight: 500;\r\n  font-family: ag;\r\n  text-align: start;\r\n  cursor: pointer;\r\n  padding-right: 20px;\r\n  padding-left: 20px;\r\n  padding-top: 15px;\r\n  padding-bottom: 15px;\r\n  margin: 0px;\r\n}\r\n\r\n.dashboard-filter-contaier {\r\n  padding-top: 15px;\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.dashboard-menu-btn {\r\n  cursor: pointer;\r\n}\r\n\r\n.dashboard-menu-btn:hover {\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  scale: 1.1;\r\n}\r\n\r\n.footer-bg {\r\n  background-color: #35353566;\r\n  margin: 0px;\r\n}\r\n\r\n.dashboard-modal {\r\n  background-color: #1d1c2e;\r\n}\r\n\r\n.tooltip-container {\r\n  background-color: #4b495c;\r\n  border-radius: 5px;\r\n  border: 1px solid #28263d;\r\n  padding: 10px;\r\n  opacity: 0.8;\r\n}\r\n\r\n.chat-height {\r\n  height: calc(100vh - 380px) !important;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
